import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail } from 'lucide-react';
export function MidPageCTA() {
  return <section className="py-24 bg-white relative" data-id="element-344">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-345">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-off-white p-10 md:p-16 rounded-sm border-l-4 border-brand-teal shadow-xl text-center" data-id="element-346">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6 leading-tight" data-id="element-347">
            You've seen how we work. The next step is a conversation.
          </h2>

          <p className="text-lg text-brand-charcoal/80 mb-10 leading-relaxed" data-id="element-348">
            Most leaders who contact us wish they had reached out sooner. A
            30-minute confidential call costs nothing and changes everything.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-349">
            <a href="#consultation" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-brand-magenta hover:bg-brand-plum text-white px-8 py-4 rounded-sm font-semibold transition-all shadow-lg shadow-brand-magenta/30 hover:shadow-xl text-center" data-id="element-350">
              <Phone size={18} data-id="element-351" />
              Book a confidential call
            </a>
            <a href="mailto:info@equipme-coachconsult.com" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-transparent border-2 border-brand-teal hover:bg-brand-teal/10 text-brand-teal px-8 py-4 rounded-sm font-semibold transition-all text-center" data-id="element-352">
              <Mail size={18} data-id="element-353" />
              Send a confidential enquiry
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-brand-charcoal/60 font-medium" data-id="element-354">
            <span className="flex items-center gap-2" data-id="element-355">
              <span className="w-2 h-2 rounded-full bg-brand-teal" data-id="element-356"></span>
              No obligation
            </span>
            <span className="flex items-center gap-2" data-id="element-357">
              <span className="w-2 h-2 rounded-full bg-brand-magenta" data-id="element-358"></span>
              Fully confidential
            </span>
            <span className="flex items-center gap-2" data-id="element-359">
              <span className="w-2 h-2 rounded-full bg-brand-orange" data-id="element-360"></span>
              Typically responds within 24 hours
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}